import {Text, View} from 'react-native'
import {usePalette} from '#/lib/hooks/usePalette'
import {useTheme} from '#/alf'
import {atoms as a} from '#/alf'

export function Logotype({
  fill,
  ...rest
}: {fill?: string} & {width?: number | string; height?: number | string; style?: any}) {
  const pal = usePalette('default')
  const t = useTheme()
  // @ts-ignore it's fiiiiine
  const size = parseInt(rest.width || 32)

  return (
    <View
      style={[
        {
          width: size,
          height: size * 0.265, // Approximate ratio to maintain similar proportions
        },
        rest.style,
      ]}>
      <Text
        style={[
          a.text_lg,
          a.font_bold,
          {
            color: fill || pal.text.color || t.atoms.text.color,
            fontSize: size * 0.4, // Scale font size based on width
            lineHeight: size * 0.265,
          },
        ]}>
        SHXRE
      </Text>
    </View>
  )
}
